/** Normalize email_verified from API / session (SQLite may return 0|1 or strings). */
export function isEmailVerified(userOrFlag) {
  if (userOrFlag && typeof userOrFlag === 'object') {
    return isEmailVerified(userOrFlag.email_verified);
  }
  const v = userOrFlag;
  return v === true || v === 1 || v === '1' || v === 'true';
}
